import React, { createContext, useReducer } from 'react';
import { asyncDispatchMiddleware } from './middlewares';

export const Store = createContext();

Store.displayName = 'Store';

export const StoreProvider = ({ children, initialState, reducer, history }) => {
  const [globalState, dispatch] = useReducer(reducer, initialState);

  return (
    <Store.Provider
      value={[
        globalState,
        asyncDispatchMiddleware(
          asyncDispatchMiddleware(
            asyncDispatchMiddleware(dispatch, globalState, history),
            globalState,
            history
          ),
          globalState,
          history
        ),
      ]}
    >
      {children}
    </Store.Provider>
  );
};
